export default __webpack_public_path__ + "3bfcb04e4bb3daf04242bef643728753.png";